import React from 'react';
import { Helmet } from 'react-helmet';
import Icons from 'images/icons';
import './style.scss';

const Fusei = () => {
  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex" />
      </Helmet>
      <div className="flex items-center justify-center">
        <Icons.Image src={Icons.fusei} />
      </div>
    </>
  );
};

export default Fusei;
